import { useToast } from "@adafia/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { moveNode } from "@/notes/api/notes";

export const useMoveNode = () => {
	const queryClient = useQueryClient();
	const { showToast } = useToast();

	return useMutation({
		mutationKey: ["moveNode"],
		mutationFn: ({
			id,
			newParentId,
		}: {
			id: string;
			newParentId: string | null;
		}) => moveNode(id, newParentId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["tree"] });
		},
		onError: (error: Error) => {
			showToast(error.message || "Failed to move note", "error");
		},
	});
};
